<template>
    <div>
        <RoleList/>
    </div>
</template>

<script>

    import RoleList from './common/roles/RoleList.vue'

    export default {
        name: "Roles",

        components: {
            RoleList
        }
    };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Roles.vue